import { request2 } from './request';

const SApi = {
  loadGames: () => request2('/apisoft/games'),
  runGame: (name) => request2(`/apisoft/create?game=${name}`),
  close: () => request2(`/apisoft/close`),
  spinBegin: (balance, bet) =>
    request2(`/apisoft/spin-begin?balance=${balance}&bet=${bet}`),
  spinFinish: (balance, win) =>
    request2(`/apisoft/spin-finish?balance=${balance}&win=${win}`),
  changeLines: (balance) =>
    request2(`/apisoft/change-lines?balance=${balance}`),
  changeBet: (balance) => request2(`/apisoft/change-bet?balance=${balance}`),
};

window.SApi = SApi;

export default SApi;



// WEBPACK FOOTER //
// ./app/api/slots.js